import React from 'react';

import { Link } from 'react-router-dom';
import footer from '../images/footslogo.png'
import footer2 from '../images/logos.png'

const Footer = () => {
  return (
    <>
      <footer className="footer">
        <div className="footer-container">
          <div className="footer-section about">
            <h3>About Us</h3>
            <p>
             Founded with a passion for elevating interiors, A S Traders is a leading name in Lucknow, Uttar Pradesh, renowned as a premier PVC Panel Wholesaler, Wallpaper Dealer, and Interior Designer. Since our inception, we have been committed to delivering high-quality, affordable, and trending interior solutions that cater to a diverse clientele, including homes, offices, hotels, malls, and commercial establishments. 
            </p>
          </div>

          <div className="footer-section links">
            <h3>Quick Links</h3>
            <ul>
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about">About</Link></li>
              <li><Link to="/services">Services</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>

          <div className="footer-section services">
            <h3>Services</h3>
            <ul className="interior-services-list">
              <li>PVC Panel</li>
              <li>Wallpaper</li>
              <li>Grass</li>
              <li>Flooring</li>
              <li>Wooden Flooring</li>
              <li>Plank</li>
              <li>Foam Sheet</li>
              <li>PVC Door</li>
              <li>Louvers panel</li>
              <li>Flute panel</li>
              <li>UV marble sheet</li>
             
            </ul>
          </div>

          <div className="footer-section contact">
            <h3>Contact</h3>
            <p>✉️ Email:  contact@astraders.com</p>
            <p> 📞 Phone: +91 9140111654</p>
            <p>📍 Address:   Grain Market, 93/25, Latouche Rd, opposite Bank of Baroda Building, Ganeshganj, Aminabad, Lucknow, Uttar Pradesh 226018</p>
          </div>
        </div>
        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()}  A S Traders - PVC Panel Wholesaler in Lucknow || Wallpaper Dealer in Lucknow || Interior Designer in Lucknow ||  All Rights Reserved.</p>

          <p>Powered By <img src={footer}/>   </p>
        
        </div>
      </footer>

      {/* Sticky WhatsApp Button */}
      <a
        href="https://wa.me/9140111654"
        className="whatsapp-float"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img src="https://img.icons8.com/color/48/000000/whatsapp--v1.png" alt="WhatsApp" />
      </a>



<a
  href="tel:+919140111654"
  className="call-float"
  target="_blank"
  rel="noopener noreferrer"
>
  <img src="https://img.icons8.com/color/48/000000/phone.png" alt="Call" />
</a>

      <div className="icon-bar">
        <a href="#" class="facebook"><i class="fa fa-facebook"></i></a>
        <a href="#" class="twitter"><i class="fa fa-twitter"></i></a>
        <a href="https://www.google.com" class="google"><i class="fa fa-google"></i></a>
        <a href="#" class="linkedin"><i class="fa fa-linkedin"></i></a>
        <a href="#" class="youtube"><i class="fa fa-youtube-play"></i></a>
      </div>







    </>
  );
};

export default Footer;
